import { render, staticRenderFns } from "./ManageProductSpecCompanies.vue?vue&type=template&id=65b765b5&scoped=true"
import script from "./ManageProductSpecCompanies.vue?vue&type=script&lang=js"
export * from "./ManageProductSpecCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b765b5",
  null
  
)

export default component.exports